import { useTranslation } from "react-i18next";import React from 'react';
import { cn } from '@/shared/utils';

export const OIGStatCard = ({
  title,
  value,
  icon: Icon,
  color = 'cyan',
  subtitle,
  trend,
  suffix = ''
}) => {const { t } = useTranslation("oig");
  const colorClasses = {
    cyan: 'bg-cyan-500/10 text-cyan-600',
    green: 'bg-emerald-500/10 text-emerald-600',
    blue: 'bg-blue-500/10 text-blue-600',
    amber: 'bg-amber-500/10 text-amber-600',
    red: 'bg-red-500/10 text-red-600',
    violet: 'bg-violet-500/10 text-violet-600',
    orange: 'bg-orange-500/10 text-orange-600'
  };

  return (
    <div className="card-elevated p-6 rounded-xl">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
            {title}
          </p>
          <p className="text-3xl font-bold mt-2 font-['Space_Grotesk']">
            {typeof value === 'number' ? value.toLocaleString() : value}
            {suffix && <span className="text-xl ml-1">{suffix}</span>}
          </p>
          {subtitle &&
          <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
          }
          {trend &&
          <div className={cn(
            'flex items-center gap-1 mt-2 text-sm font-medium',
            trend.type === 'up' ? 'text-emerald-600' : 'text-red-600'
          )}>
              <span>{trend.type === 'up' ? '↑' : '↓'}</span>
              <span>{trend.value}%</span>
            </div>
          }
        </div>
        <div className={cn('p-3 rounded-xl', colorClasses[color])}>
          <Icon className="h-6 w-6" />
        </div>
      </div>
    </div>);

};